import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import PayPalPayment from '../PayPalPayment';

const BuyerPaymentModal = ({
  open, pendingRegistration, formatPrice, t,
  handlePaymentSuccess, handlePaymentError, handlePaymentCancel,
}) => {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) handlePaymentCancel(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('dashboard.complete_registration')}</DialogTitle>
          <DialogDescription>{t('dashboard.pay_entry_fee', { event: pendingRegistration?.event?.name })}</DialogDescription>
        </DialogHeader>
        {pendingRegistration && (
          <>
            {pendingRegistration.coupon && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
                <p className="text-sm text-green-700 font-medium">{t('dashboard.coupon_code_applied', { code: pendingRegistration.coupon.code })}</p>
                <div className="mt-2 text-sm space-y-1">
                  <div className="flex justify-between"><span className="text-slate-600">{t('dashboard.original_price')}</span><span className="text-slate-600">{formatPrice(pendingRegistration.originalAmount)}</span></div>
                  <div className="flex justify-between text-green-600"><span>{t('dashboard.discount_amount')} ({pendingRegistration.coupon.discount_percent}%):</span><span>-{formatPrice(pendingRegistration.originalAmount - pendingRegistration.finalAmount)}</span></div>
                  <div className="flex justify-between font-semibold border-t pt-1 mt-1"><span>{t('dashboard.total_price')}</span><span>{formatPrice(pendingRegistration.finalAmount)}</span></div>
                </div>
              </div>
            )}
            <PayPalPayment amount={pendingRegistration.finalAmount || pendingRegistration.event.buyer_fee} paymentType="buyer_registration"
              referenceId={pendingRegistration.isNew ? null : pendingRegistration.id} pendingEventId={pendingRegistration.isNew ? pendingRegistration.event_id : null}
              couponCode={pendingRegistration.coupon?.code || null}
              description={`Exhibit Entry Fee - ${pendingRegistration.event.name}${pendingRegistration.coupon ? ` (Coupon: ${pendingRegistration.coupon.code})` : ''}`}
              onSuccess={handlePaymentSuccess} onError={handlePaymentError} onCancel={handlePaymentCancel} />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default BuyerPaymentModal;
